import { useState } from "react";

const ACTION_TYPES = [
    { value: "block", label: "Block Service" },
    { value: "warn", label: "Show Warning" },
    { value: "proceed", label: "Continue" },
];

const ACTION_STYLES = {
    block: "bg-red-100 text-red-700 border-red-200",
    warn: "bg-yellow-100 text-yellow-700 border-yellow-200",
    proceed: "bg-green-100 text-green-700 border-green-200",
};

const EligibilityCustomQuestions = ({
    customQuestions,
    updateCustomQuestions,
}) => {

    const [newQuestion, setNewQuestion] = useState("");

    /*
    --------------------------------------------------
    Add Question
    --------------------------------------------------
    */

    const addQuestion = () => {

        if (!newQuestion.trim()) return;

        const updated = [

            ...customQuestions,

            {

                question: newQuestion,

                fieldType: "radio",

                customQuestion: true,

                options: [

                    {
                        label: "Yes",
                        type: "proceed",
                    },

                    {
                        label: "No",
                        type: "proceed",
                    },

                ],

            },

        ];

        updateCustomQuestions(updated);

        setNewQuestion("");

    };

    /*
    --------------------------------------------------
    Delete Question
    --------------------------------------------------
    */

    const removeQuestion = (index) => {

        const updated = [...customQuestions];

        updated.splice(index, 1);

        updateCustomQuestions(updated);

    };

    /*
    --------------------------------------------------
    Update Option
    --------------------------------------------------
    */

    const updateOption = (questionIndex, optionIndex, newType) => {

        const updated = [...customQuestions];

        updated[questionIndex].options[optionIndex].type = newType;

        updateCustomQuestions(updated);

    };

    /*
    --------------------------------------------------
    Render
    --------------------------------------------------
    */

    return (

        <div className="bg-white rounded-xl shadow-sm p-6">

            <div className="font-semibold mb-4">

                Custom Questions (Optional)

            </div>

            {customQuestions.map((question, questionIndex) => (

                <div

                    key={question._id || questionIndex}

                    className="border rounded-lg px-4 py-3 mb-4"

                >

                    <div className="flex justify-between items-center mb-3">

                        <div className="font-medium">

                            {question.question}

                        </div>

                        <button

                            onClick={() =>
                                removeQuestion(questionIndex)
                            }

                            className="text-red-500 text-sm"

                        >

                            Delete

                        </button>

                    </div>

                    {(question.options || []).map((option, optionIndex) => (

                        <div

                            key={option._id || optionIndex}

                            className="flex justify-between items-center border rounded-md px-3 py-2 mb-2"

                        >

                            <span>

                                {option.label}

                            </span>

                            <select

                                value={option.type}

                                onChange={(e) =>

                                    updateOption(

                                        questionIndex,

                                        optionIndex,

                                        e.target.value

                                    )

                                }

                                className={`border rounded-full px-3 py-1 text-sm ${ACTION_STYLES[option.type]}`}

                            >

                                {ACTION_TYPES.map(action => (

                                    <option

                                        key={action.value}

                                        value={action.value}

                                    >

                                        {action.label}

                                    </option>

                                ))}

                            </select>

                        </div>

                    ))}

                </div>

            ))}

            <div className="flex gap-3 mt-5">

                <input

                    value={newQuestion}

                    onChange={(e) =>
                        setNewQuestion(e.target.value)
                    }

                    placeholder="Add a question"

                    className="flex-1 border rounded-lg px-4 py-2"

                />

                <button

                    onClick={addQuestion}

                    className="bg-gray-100 hover:bg-gray-200 px-5 rounded-lg"

                >

                    Add

                </button>

            </div>

        </div>

    );

};

export default EligibilityCustomQuestions;